// MODULES
import moment from "moment";

// MUI COMPONENTS
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
//import mui thumbs up icon
import ThumbUpIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownIcon from "@mui/icons-material/ThumbDownOffAlt";

import useCrmEvent from "./useCrmEvent";

const CrmEvent = props => {
  const { event, past, needsAction, handleAttendance } = useCrmEvent(props);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
        mt: 1.2,
        mb: 1.5,
        border: "3.5px solid #efefef",
        borderRadius: "20px",
        padding: 1.2
      }}
    >
      <Box
        sx={{
          width: "120px",
          height: "100%",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          ml: 1
        }}
      >
        <Chip
          label={event.Type}
          sx={{
            fontWeight: 600,
            color: "#878787",
            backgroundColor: "#efefef",
            borderRadius: 0
          }}
        />
      </Box>
      <Box
        sx={{
          width: "inherit",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center"
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 0.8
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 0.3
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <Typography
                sx={{
                  width: "88%",
                  fontFamily: "Lato",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "common.black",
                  lineHeight: 0.9
                }}
              >
                {event.Title}
              </Typography>
              <Typography
                sx={{
                  width: "12%",
                  fontFamily: "Lato",
                  fontSize: "14px",
                  fontWeight: 800,
                  color: "#878787",
                  lineHeight: 0.9
                }}
              >
                {event.Author}
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "row"
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Lato",
                  fontSize: "14px",
                  fontWeight: 800,
                  color: "#878787",
                  lineHeight: 0.9
                }}
              >
                {(past ? "Genomförd aktivitet: " : "Kommande aktivitet: ") +
                  moment(event.StartTime).format("YYYY-MM-DD") +
                  ", " +
                  moment(event.StartTime).format("HH:mm") +
                  " - " +
                  (moment(event.StartTime).isSame(moment(event.EndTime), "day")
                    ? moment(event.EndTime).format("HH:mm")
                    : moment(event.EndTime).format("YYYY-MM-DD HH:mm"))}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            mt: 2
          }}
        >
          <Typography
            sx={{
              fontFamily: "Lato",
              fontSize: "14px",
              fontWeight: 600,
              color: "#878787",
              lineHeight: 0.9
            }}
          >
            {event.Description}
          </Typography>
        </Box>
        {needsAction ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              mt: 2
            }}
          >
            <Typography
              sx={{
                fontFamily: "Lato",
                fontSize: "14px",
                fontWeight: 600,
                color: "#878787",
                lineHeight: 0.9
              }}
            >
              Deltog kunden pa eventet?
            </Typography>
            <Box
              sx={{ display: "flex", gap: 1, flexDirection: "row", mt: 1.5 }}
            >
              <Button
                variant="outlined"
                onClick={() => handleAttendance(event, "yes")}
              >
                Ja
              </Button>
              <Button
                variant="outlined"
                onClick={() => handleAttendance(event, "no")}
              >
                Nej
              </Button>
            </Box>
          </Box>
        ) : (
          past && (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                mt: 2
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Lato",
                  fontSize: "14px",
                  fontWeight: 600,
                  color: event.Attended === "yes" ? "green" : "red",
                  lineHeight: 0.9,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5
                }}
              >
                {event.Attended === "yes" ? (
                  <>
                    <ThumbUpIcon /> Kund deltog pa event.
                  </>
                ) : (
                  <>
                    <ThumbDownIcon /> Kund deltog inte pa event.
                  </>
                )}
              </Typography>
            </Box>
          )
        )}
      </Box>
    </Box>
  );
};

export default CrmEvent;
